import React, { PureComponent } from 'react';

class MainPage extends PureComponent {
  render() {
    return (
      <div>
        <h3>Добрый день!</h3>
        <p>Через пару минут вы узнаете много
          информации, которая может изменить вас.
          Но для начала давайте познакомимся.</p>
      </div>
    )
  }
}

export default MainPage;
